// Fields hierarchy and list for Catatan Pemeriksaan Kegiatan
export const reviewFields = [
      {
        id: "judul-kegiatan",
        label: "Judul Kegiatan",
      },
      {
        id: "tahun",
        label: "Tahun",
      },
      {
        id: "cara-pengumpulan-data",
        label: "Cara Pengumpulan Data",
      },
      {
        id: "sektor-kegiatan",
        label: "Sektor Kegiatan",
      },
      {
        id: "jenis-kegiatan-statistik",
        label: "Jenis Kegiatan Statistik ",
      },
      {
        id: "blok-I",
        label: "Blok I",
        children: [
          {
            id: "blok-I-instansi-penyelenggara",
            label: "1.1. Instansi Penyelenggara",
          },
          {
            id: "blok-I-alamat-lengkap-instansi-penyelenggara",
            label: "1.2. Alamat Lengkap Instansi Penyelenggara",
          },
        ],
      },
      {
        id: "blok-II",
        label: "Blok II",
        children: [
          {
            id: "blok-II-unit-eselon-penanggung-jawab",
            label: "2.1. Unit Eselon Penanggung Jawab",
          },
          {
            id: "blok-II-penanggung-jawab-teknis",
            label: "2.2. Penanggung Jawab Teknis",
          },
        ],
      },
      {
        id: "blok-III",
        label: "Blok III",
        children: [
          {
            id: "blok-III-latar-belakang-kegiatan",
            label: "3.1. Latar Belakang Kegiatan",
          },
          {
            id: "blok-III-tujuan-kegiatan",
            label: "3.2. Tujuan Kegiatan",
          },
          {
            id: "blok-III-rencana-jadwal-kegiatan",
            label: "3.3. Rencana Jadwal Kegiatan",
          },
          {
            id: "blok-III-variabel-yang-dikumpulkan",
            label: "3.4. Variabel (Karakteristik) yang Dikumpulkan",
          },
        ],
      },
      {
        id: "blok-IV",
        label: "Blok IV",
        children: [
          {
            id: "blok-IV-kegiatan-ini-dilakukan-berulang-atau-hanya-sekali",
            label: "4.1. Kegiatan ini Dilakukan Berulang atau Hanya Sekali",
          },
          {
            id: "blok-IV-frekuensi-penyelenggaraan",
            label: "4.2. Frekuensi Penyelenggaraan",
          },
          {
            id: "blok-IV-tipe-pengumpulan-data",
            label: "4.3. Tipe Pengumpulan Data",
          },
          {
            id: "blok-IV-cakupan-wilayah-pengumpulan-data",
            label: "4.4. Cakupan Wilayah Pengumpulan Data",
          },
          {
            id: "blok-IV-wilayah-kegiatan",
            label: "4.5. Wilayah Kegiatan",
          },
          {
            id: "blok-IV-metode-pengumpulan-data",
            label: "4.6. Metode Pengumpulan Data",
          },
          {
            id: "blok-IV-sarana-pengumpulan-data",
            label: "4.7 Sarana Pengumpulan Data",
          },
          {
            id: "blok-IV-unit-pengumpulan-data",
            label: "4.8. Unit Pengumpulan Data",
          },
        ],
      },
      {
        id: "blok-V",
        label: "Blok V",
        children: [
          {
            id: "blok-V-jenis-rancangan-sampel",
            label: "5.1. Jenis Rancangan Sampel",
          },
          {
            id: "blok-V-metode-pemilihan-sampel-tahap=terakhir",
            label: "5.2. Metode Pemilihan Sampel Tahap Terakhir",
          },
          {
            id: "blok-V-metode-yang-digunakan",
            label: "5.3. Metode yang Digunakan",
          },
          {
            id: "blok-V-kerangka-sampel-tahap-terakhir",
            label: "5.4. Kerangka Sampel Tahap Terakhir",
          },
          {
            id: "blok-V-fraksi-sampel-keseluruhan",
            label: "5.5. Fraksi Sampel Keseluruhan",
          },
          {
            id: "blok-V-nilai-perkiraan-sampling-error-variabel-utama",
            label: "5.6. Nilai Perkiraan Sampling Error Variabel Utama",
          },
          {
            id: "blok-V-unit-sampel",
            label: "5.7. Unit Sampel",
          },
          {
            id: "blok-V-unit-observasi",
            label: "5.8. Unit Observasi",
          },
        ],
      },
      {
        id: "blok-VI",
        label: "Blok VI",
        children: [
          {
            id: "blok-VI-apakah-melakukan-uji-coba",
            label: "6.1. Apakah Melakukan Uji Coba (Pilot Survey)",
          },
          {
            id: "blok-VI-metode-pemeriksaan-kualitas-pengumpulan-data",
            label: "6.2. Metode Pemeriksaan Kualitas Pengumpulan Data",
          },
          {
            id: "blok-VI-apakah-melakukan-penyesuaian-non-respon",
            label: "6.3. Apakah Melakukan Penyesuaian Nonrespon",
          },
          {
            id: "blok-VI-petugas-pengumpulan-data",
            label: "6.4. Petugas Pengumpulan Data",
          },
          {
            id: "blok-VI-persyaratan-pendidikan-petugas",
            label:
              "6.5. Persyaratan Pendidikan Terendah Petugas Pengumpulan Data",
          },
          {
            id: "blok-VI-jumlah-petugas",
            label: "6.6. Jumlah Petugas",
          },
          {
            id: "blok-VI-pelatihan-petugas",
            label: "6.7. Apakah Melakukan Pelatihan Petugas",
          },
        ],
      },
      {
        id: "blok-VII",
        label: "Blok VII",
        children: [
          {
            id: "blok-VII-tahapan-pengolahan-data",
            label: "7.1. Tahapan Pengolahan Data",
          },
          {
            id: "blok-VII-metode-analisis",
            label: "7.2. Metode Analisis",
          },
          {
            id: "blok-VII-unit-analisis",
            label: "7.3. Unit Analisis",
          },
          {
            id: "blok-VII-tingkat-penyajian-hasil-analisis",
            label: "7.4. Tingkat Penyajian Hasil Analisis",
          },
        ],
      },
      {
        id: "blok-VIII",
        label: "Blok VIII",
        children: [
          {
            id: "blok-VIII-produk-tersedia-untuk-umum",
            label: "8.1. Produk Kegiatan yang Tersedia untuk Umum",
          },
          {
            id: "blok-VIII-judul-dan-rencana-rilis-produk-kegiatan",
            label: "8.2. Judul dan Rencana Rilis Produk Kegiatan",
          },
        ],
      },
    ];

export const flatReviewFields = [
      {
        id: "judul-kegiatan",
        label: "Judul Kegiatan",
      },
      {
        id: "tahun",
        label: "Tahun",
      },
      {
        id: "cara-pengumpulan-data",
        label: "Cara Pengumpulan Data",
      },
      {
        id: "sektor-kegiatan",
        label: "Sektor Kegiatan",
      },
      {
        id: "jenis-kegiatan-statistik",
        label: "Jenis Kegiatan Statistik ",
      },
      {
        id: "blok-I",
        label: "Blok I",
      },
      {
        id: "blok-II",
        label: "Blok II",
      },
      {
        id: "blok-III",
        label: "Blok III",
      },
      {
        id: "blok-IV",
        label: "Blok IV",
      },
      {
        id: "blok-V",
        label: "Blok V",
      },
      {
        id: "blok-VI",
        label: "Blok VI",
      },
      {
        id: "blok-VII",
        label: "Blok VII",
      },
      {
        id: "blok-VIII",
        label: "Blok VIII",
      },
      {
        id: "blok-I-instansi-penyelenggara",
        label: "1.1. Instansi Penyelenggara",
      },
      {
        id: "blok-I-alamat-lengkap-instansi-penyelenggara",
        label: "1.2. Alamat Lengkap Instansi Penyelenggara",
      },
      {
        id: "blok-II-unit-eselon-penanggung-jawab",
        label: "2.1. Unit Eselon Penanggung Jawab",
      },
      {
        id: "blok-II-penanggung-jawab-teknis",
        label: "2.2. Penanggung Jawab Teknis",
      },
      {
        id: "blok-III-latar-belakang-kegiatan",
        label: "3.1. Latar Belakang Kegiatan",
      },
      {
        id: "blok-III-tujuan-kegiatan",
        label: "3.2. Tujuan Kegiatan",
      },
      {
        id: "blok-III-rencana-jadwal-kegiatan",
        label: "3.3. Rencana Jadwal Kegiatan",
      },
      {
        id: "blok-III-variabel-yang-dikumpulkan",
        label: "3.4. Variabel (Karakteristik) yang Dikumpulkan",
      },
      {
        id: "blok-IV-kegiatan-ini-dilakukan-berulang-atau-hanya-sekali",
        label: "4.1. Kegiatan ini Dilakukan Berulang atau Hanya Sekali",
      },
      {
        id: "blok-IV-frekuensi-penyelenggaraan",
        label: "4.2. Frekuensi Penyelenggaraan",
      },
      {
        id: "blok-IV-tipe-pengumpulan-data",
        label: "4.3. Tipe Pengumpulan Data",
      },
      {
        id: "blok-IV-cakupan-wilayah-pengumpulan-data",
        label: "4.4. Cakupan Wilayah Pengumpulan Data",
      },
      {
        id: "blok-IV-wilayah-kegiatan",
        label: "4.5. Wilayah Kegiatan",
      },
      {
        id: "blok-IV-metode-pengumpulan-data",
        label: "4.6. Metode Pengumpulan Data",
      },
      {
        id: "blok-IV-sarana-pengumpulan-data",
        label: "4.7 Sarana Pengumpulan Data",
      },
      {
        id: "blok-IV-unit-pengumpulan-data",
        label: "4.8. Unit Pengumpulan Data",
      },
      {
        id: "blok-V-jenis-rancangan-sampel",
        label: "5.1. Jenis Rancangan Sampel",
      },
      {
        id: "blok-V-metode-pemilihan-sampel-tahap=terakhir",
        label: "5.2. Metode Pemilihan Sampel Tahap Terakhir",
      },
      {
        id: "blok-V-metode-yang-digunakan",
        label: "5.3. Metode yang Digunakan",
      },
      {
        id: "blok-V-kerangka-sampel-tahap-terakhir",
        label: "5.4. Kerangka Sampel Tahap Terakhir",
      },
      {
        id: "blok-V-fraksi-sampel-keseluruhan",
        label: "5.5. Fraksi Sampel Keseluruhan",
      },
      {
        id: "blok-V-nilai-perkiraan-sampling-error-variabel-utama",
        label: "5.6. Nilai Perkiraan Sampling Error Variabel Utama",
      },
      {
        id: "blok-V-unit-sampel",
        label: "5.7. Unit Sampel",
      },
      {
        id: "blok-V-unit-observasi",
        label: "5.8. Unit Observasi",
      },
      {
        id: "blok-VI-apakah-melakukan-uji-coba",
        label: "6.1. Apakah Melakukan Uji Coba (Pilot Survey)",
      },
      {
        id: "blok-VI-metode-pemeriksaan-kualitas-pengumpulan-data",
        label: "6.2. Metode Pemeriksaan Kualitas Pengumpulan Data",
      },
      {
        id: "blok-VI-apakah-melakukan-penyesuaian-non-respon",
        label: "6.3. Apakah Melakukan Penyesuaian Nonrespon",
      },
      {
        id: "blok-VI-petugas-pengumpulan-data",
        label: "6.4. Petugas Pengumpulan Data",
      },
      {
        id: "blok-VI-persyaratan-pendidikan-petugas",
        label: "6.5. Persyaratan Pendidikan Terendah Petugas Pengumpulan Data",
      },
      {
        id: "blok-VI-jumlah-petugas",
        label: "6.6. Jumlah Petugas",
      },
      {
        id: "blok-VI-pelatihan-petugas",
        label: "6.7. Apakah Melakukan Pelatihan Petugas",
      },
      {
        id: "blok-VII-tahapan-pengolahan-data",
        label: "7.1. Tahapan Pengolahan Data",
      },
      {
        id: "blok-VII-metode-analisis",
        label: "7.2. Metode Analisis",
      },
      {
        id: "blok-VII-unit-analisis",
        label: "7.3. Unit Analisis",
      },
      {
        id: "blok-VII-tingkat-penyajian-hasil-analisis",
        label: "7.4. Tingkat Penyajian Hasil Analisis",
      },
      {
        id: "blok-VIII-produk-tersedia-untuk-umum",
        label: "8.1. Produk Kegiatan yang Tersedia untuk Umum",
      },
      {
        id: "blok-VIII-judul-dan-rencana-rilis-produk-kegiatan",
        label: "8.2. Judul dan Rencana Rilis Produk Kegiatan",
      },
    ];
